var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconModal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5333 16L5.70711 7.17379C5.31658 6.78326 5.31327 6.14471 5.71271 5.76331C5.72567 5.75094 5.7374 5.7398 5.74804 5.72976C6.15709 5.34391 6.79451 5.32786 7.19213 5.72548L16 14.5333L24.8262 5.70711C25.2167 5.31658 25.8499 5.31658 26.2404 5.70711L26.2929 5.75956C26.6834 6.15008 26.6834 6.78325 26.2929 7.17377L17.4667 16L26.2929 24.8262C26.6834 25.2168 26.6834 25.8499 26.2929 26.2404L26.2404 26.2929C25.8499 26.6834 25.2168 26.6834 24.8262 26.2929L16 17.4667L7.17377 26.2929C6.78325 26.6834 6.1447 26.6867 5.7633 26.2873C5.75092 26.2743 5.73979 26.2626 5.72975 26.2519C5.3439 25.8429 5.32785 25.2055 5.72547 24.8079L14.5333 16Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconModal);
export default __webpack_public_path__ + "static/media/close_icon_modal.23c1861f.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconModal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5333 16L5.70711 7.17379C5.31658 6.78326 5.31327 6.14471 5.71271 5.76331C5.72567 5.75094 5.7374 5.7398 5.74804 5.72976C6.15709 5.34391 6.79451 5.32786 7.19213 5.72548L16 14.5333L24.8262 5.70711C25.2167 5.31658 25.8499 5.31658 26.2404 5.70711L26.2929 5.75956C26.6834 6.15008 26.6834 6.78325 26.2929 7.17377L17.4667 16L26.2929 24.8262C26.6834 25.2168 26.6834 25.8499 26.2929 26.2404L26.2404 26.2929C25.8499 26.6834 25.2168 26.6834 24.8262 26.2929L16 17.4667L7.17377 26.2929C6.78325 26.6834 6.1447 26.6867 5.7633 26.2873C5.75092 26.2743 5.73979 26.2626 5.72975 26.2519C5.3439 25.8429 5.32785 25.2055 5.72547 24.8079L14.5333 16Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconModal);
export default __webpack_public_path__ + "static/media/close_icon_modal.23c1861f.svg";
export { ForwardRef as ReactComponent };